import React from 'react'
import '../Styles/Home.scss'
import home2 from "../Assets/home2.png"
// import {AiFillFacebook, AiFillInstagram,AiOutlineWhatsApp,AiFillRedEnvelope} from "react-icons/ai" 
import{FaClipboardCheck,FaPenFancy,FaCheck,FaHandshake} from "react-icons/fa";
const Home = () => {
  return (
   <>
    <div className='home' id='home'>
<main>
    <h1>Pramukh Finserve</h1>
    <p>Your Financial Partner</p>
    </main> 
        
</div>
<div className="home2" >
    <img src={home2} alt="Graphics" />
<div>
    <p>
        We are your financial consultant of loans,Insurance and Mutual funds.We are specialized in rendering customized financial solutions to our clients as per their needs, requirements and demands
    </p>
</div>
</div>

<div className="home3" id='about'>
    <div>
    <h1>Who we are?</h1>
    <p>Pramukh Finserve is professionally managed services oriented & knowledge based firm for providing one-stop financial advisory and fund raising solutions in Home loan, Mortgage loan, Personal loan,Business loan,Car loan and Project Finance.</p>

<p>Our mission is to provide our business partner with the development, implementation and management of uniquely tailored business solutions that will help our clients to grow in their respective business/Industries.</p>

<p>
We believe in the value of long term relationships. We view every client relationship like a partnership, and truly believe that our success is a result of your success. We are committed to providing close, personal attention to our clients. </p>
</div>
</div>
<div className="home4" id='LoanProcess'>

    <div>
    <h1>Loan Process</h1>
    <article>
        <div style={{animationDelay:"0.3s"}}>
            <FaClipboardCheck/>
            <p>Loan Application</p>
        </div>
        <div style={{animationDelay:"0.7s"}}>
            <FaPenFancy/>
            <p>UnderWriting</p>
        </div>
        <div style={{animationDelay:"0.11s"}}>
            <FaCheck/>
            <p>Approval</p>
        </div>
        <div style={{animationDelay:"0.15s"}}>
            <FaHandshake/>
            <p>Closing</p>
        </div>
    </article>
    </div>
</div>
   </>
  )
}

export default Home;